import { createIntl, createIntlCache, defineMessages } from "react-intl";
import { z } from "zod";
import messagesEn from "../../../translations/en.json";
import messagesEs from "../../../translations/es.json";

const locale = window.localStorage.getItem("locale") || navigator.language;
const messages: Record<string, Record<string, string>> = {
  "en-US": messagesEn,
  "es-ES": messagesEs,
};

const cache = createIntlCache();
let intl = createIntl({ locale, messages: messages[locale] }, cache);

const validationMessages = defineMessages({
  numberTooSmall: {
    id: "app.input.numberTooSmall",
    defaultMessage: "Number must be greater than or equal to {value}",
  },
});

// TODO - add all zod validation translations here
const customErrorMap: z.ZodErrorMap = (issue, ctx) => {
  if (issue.code === z.ZodIssueCode.too_small) {
    return {
      message: intl.formatMessage(validationMessages.numberTooSmall, {
        value: issue.minimum.toString(),
      }),
    };
  }
  return { message: ctx.defaultError };
};

z.setErrorMap(customErrorMap);

export const setZodLocale = (locale: string) => {
  intl = createIntl({ locale, messages: messages[locale] }, cache);
};
